import React from 'react';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import useGetList from 'Hooks/query-hooks/list/useGetList';

import RouteLoading from 'Components/RouteLoading';
import errorController from 'Components/ErrorScreens';
import CreateSimpleRuleLayout from './CreateSimpleRuleLayout';

const CreateSimpleRulePage = () => {
    const parametersAPI = useGetParameters({
        queryParams: { status: JSON.stringify(['active']) }
    });
    const listsAPI = useGetList();

    if (parametersAPI.isLoading || parametersAPI.isFetching || listsAPI.isLoading || listsAPI.isFetching) {
        return <RouteLoading />;
    }

    if (parametersAPI.isError || listsAPI.isError) {
        const { errorCmp } = errorController([parametersAPI.error, listsAPI.error]);
        return errorCmp;
    }

    return <CreateSimpleRuleLayout parameterData={parametersAPI.data} listData={listsAPI.data} />;
};

export default CreateSimpleRulePage;
